import BaseApiAction from '@Actions/base-api-action';

export default class SecureDeleteUser extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'secure-secureDeleteUser',
      payload: {
        secure_key: this._payload.secure_key,
        user_id: this._payload.user_id,
        auth_id: this._payload.auth_id,
      },
    });
  }

  onSuccess(data) {
    this._state.admin.users.events.userDeleted.emit();
    super.onSuccess(data);
  }
}
